// extracted by mini-css-extract-plugin
export default {"calc":"style_calc__r657a"};